import { ImgExt } from './img.model';

const isImgExt = (ext: string | undefined): ext is ImgExt => ['jpg', 'png'].includes(ext || '');

export const toImageUri = (fileName: string, base64: string): string => {
  const bytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
  const imageExtension = fileName.split('.').pop();
  return URL.createObjectURL(new Blob([bytes], { type: `img/${isImgExt(imageExtension) ? imageExtension : 'jpg'}` }));
};
